package com.shadowings.gero.data.lessons.chapter10

import com.shadowings.gero.data.lessons.chapter2.getNumberGenderQuizContent
import com.shadowings.gero.data.lessons.chapter2.getVocabAnimalsContent
import com.shadowings.gero.data.lessons.chapter2.getVocabAnimalsQuizContent
import com.shadowings.gero.data.lessons.chapter2.getVocabFoodContent
import com.shadowings.gero.data.lessons.chapter2.getVocabFoodQuizContent
import com.shadowings.gero.data.lessons.chapter2.getVocabHumansContent
import com.shadowings.gero.data.lessons.chapter2.getVocabHumansQuizContent
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_1
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_2
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_3
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_4
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_5
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_6
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_7
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_8
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_9
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_10
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_11
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_12
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_13
import gero.composeapp.generated.resources.exp_content_il_grande_ritorno_14
import gero.composeapp.generated.resources.exp_title_il_grande_ritorno

fun getIlGrandeRitornoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_1,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_2,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_3,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_4,
            face = Faces.Sad,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_5,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_6,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_7,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_8,
            face = Faces.Surprised,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_9,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_10,
            face = Faces.Surprised,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_11,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_12,
            face = Faces.Idle,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_13,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_grande_ritorno,
            content = Res.string.exp_content_il_grande_ritorno_14,
            face = Faces.Happy,
            character = Characters.Alyn,
        )
    )
}

fun getIlGrandeRitornoQuizContent(
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return (
        getNumberGenderQuizContent().take(1)
            + getVocabFoodQuizContent(
                getVocabFoodContent(words, languageCode),
                words,
                languageCode
            ).take(3)
            + getVocabAnimalsQuizContent(
                getVocabAnimalsContent(words, languageCode),
                words,
                languageCode
            ).take(3)
            + getVocabHumansQuizContent(
                getVocabHumansContent(words, languageCode),
                words,
                languageCode
            ).take(3)
    )
}
